export default {
  CapacityTon: 'ظرفیت(تن)',
  HeightMeter: 'ارتفاع',
  LengthMeter: 'طول',
  NewMeasurementAdd: 'اندازه گیری جدید اضافه شد',
  NewCurrencyAdd: 'واحد پولی جدید اضافه شد',
  MaesurementUpdate: 'اندازه گیری بروزرسانی شد',
  CurrencyUpdate: 'واحد پولی بروزرسانی شد',
  MeasurementRemoved: 'اندازه گیری حذف شد',
  UserGroupRemoved: 'واحد پولی حذف شد',
  TypeMeasurement: 'نوع اندازه گیری',
  TypeCurrency: 'نوع واحد پولی',
  DecimalPlaces: 'تعداد اعشار',
  Order: 'ترتیب',
  Slug: 'Slug',
  Symbol: 'نماد',
  Enable: 'فعال',
  Disable: 'غیر فعال',
  WidthMeter: 'عرض',
  capacity: 'ظرفیت',
  length: 'طول',
  width: 'عرض',
  height: 'ارتفاع',
  hour: 'ساعت',
  minutes: 'دقیقه',
  kilometer: 'کیلومتر',
  meter: 'متر',
  tons: 'تُن',
  kilogerams: 'کیلو گرم',
  grams: 'گرم',
  unit: 'عدد'
}
